"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useRecommendationPlans = require("../../../hooks/recommendation/useRecommendationPlans");
var _RecommendationPlanTabs = _interopRequireDefault(require("./RecommendationPlanTabs"));
var _AdditionalAirtimePlans = _interopRequireDefault(require("./AdditionalAirtimePlans"));
var _r10SourceLibrary = require("r10-source-library");
var _UpsellBreakdown = _interopRequireDefault(require("../../Upsell/UpsellBreakdown"));
var _useDevSettings = require("../../../hooks/app/useDevSettings");
var _UpsellBreakdownWrapper = _interopRequireDefault(require("../../Upsell/UpsellBreakdownWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RecommendationAirtimePlans = () => {
  const {
    recommendedPlan,
    premiumPlan,
    budgetPlan,
    alternativePremiumPlan,
    alternativeBudgetPlan,
    selectedPlan
  } = (0, _useRecommendationPlans.useRecommendationPlans)();
  const plans = [recommendedPlan, premiumPlan, alternativePremiumPlan, alternativeBudgetPlan, budgetPlan].filter(plan => plan);
  const {
    showOtherPlans
  } = (0, _useDevSettings.useDevSettings)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RecommendationPlanTabs.default, {
    plans: plans,
    selectedPlan: selectedPlan
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, showOtherPlans && /*#__PURE__*/_react.default.createElement(_AdditionalAirtimePlans.default, {
    plans: plans
  })), /*#__PURE__*/_react.default.createElement(_UpsellBreakdownWrapper.default, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, null, /*#__PURE__*/_react.default.createElement(_UpsellBreakdown.default, null))));
};
var _default = RecommendationAirtimePlans;
exports.default = _default;